// styles and images
import './Components.css'
import Edit from '../assets/edit.svg'


export default function EditSelected({setEditIsTriggered, setId, id}) {
    const handleClick = () => {
        setId(id)
        setEditIsTriggered(true)
    }    
    return (
        <div className='edits'>
                <img 
                    src={Edit} 
                    className='edit'
                    onClick={handleClick}
                    alt='edit'
                />
        </div>
    )
}
